// src/theme/filterstyles.js

const BRAND_BLUE = "#00336C";
const BRAND_BLUE_DARK = "#00254F";
const BRAND_BORDER = "rgba(0, 51, 108, 0.2)";
const BRAND_SHADOW = "0 10px 24px rgba(0, 51, 108, 0.12)";

export const FILTER_STYLES = {
  formControl: {
    flex: 1,
    minWidth: 160,

    /* =======================================================
       SHARED INPUT ROOT STYLING (Select + Autocomplete)
    ======================================================= */
    "& .MuiOutlinedInput-root, & .MuiAutocomplete-inputRoot": {
      height: 42,
      fontSize: "0.95rem",
      color: "#00336C",

      borderRadius: 3,
      background:
        "linear-gradient(180deg, rgba(231,240,218,0.25) 0%, #ffffff 80%)",
      boxShadow: "0 4px 14px rgba(0, 51, 108, 0.12)",

      /* Default border */
      "& fieldset": {
        border: "2px solid #00336C",
      },

      /* Hover */
      "&:hover fieldset": {
        borderColor: "#00336C",
      },

      /* Focus */
      "&.Mui-focused fieldset": {
        borderColor: "#00336C",
        borderWidth: 2,
      },
    },

    /* =======================================================
       LABEL STYLING
    ======================================================= */
    "& .MuiInputLabel-root": {
      fontWeight: 600,
      color: "#00336C",
    },

    "& .MuiInputLabel-root.Mui-focused": {
      color: "#00336C",
    },

    /* =======================================================
       Autocomplete Dropdown Indicator
    ======================================================= */
    "& .MuiAutocomplete-popupIndicator": {
      color: "#00336C",
    },

    "& .MuiAutocomplete-clearIndicator": {
      color: "#00336C",
    },

    /* =======================================================
       Chips (for future multi-select usage)
    ======================================================= */
    "& .MuiChip-root": {
      backgroundColor: "#e7f0da",
      color: "#00336C",
      fontWeight: 600,
      borderRadius: "6px",
    },
  },

  /* =======================================================
     SELECT-SPECIFIC OPTIONS
  ======================================================= */
  select: {
    displayEmpty: true,
    size: "small",
    sx: {
      fontSize: "0.95rem",
      color: "#00336C",

      "& .MuiSelect-icon": {
        color: "#00336C",
      },
    },
    MenuProps: {
      PaperProps: {
        sx: {
          maxHeight: 300,
          border: "1px solid #00336C",
        },
      },
    },
  },
};

export const AUTOCOMPLETE_DROPDOWN_SLOT_PROPS = {
  paper: {
    elevation: 0,
    sx: {
      mt: 1,
      borderRadius: "16px",
      border: `1px solid ${BRAND_BORDER}`,
      boxShadow: BRAND_SHADOW,
      overflow: "hidden",
      backgroundImage: "none",
    },
  },
  listbox: {
    sx: {
      py: 0.75,
      "& .MuiAutocomplete-option": {
        mx: 0.75,
        my: 0.25,
        minHeight: 40,
        borderRadius: "10px",
        color: BRAND_BLUE_DARK,
        fontSize: "0.94rem",
        transition: "background-color 140ms ease, color 140ms ease",
      },
      "& .MuiAutocomplete-option[aria-selected='true']": {
        backgroundColor: "rgba(0, 51, 108, 0.1)",
        color: BRAND_BLUE,
        fontWeight: 700,
      },
      "& .MuiAutocomplete-option.Mui-focused": {
        backgroundColor: "rgba(0, 51, 108, 0.06)",
      },
      "& .MuiAutocomplete-option[aria-selected='true'].Mui-focused": {
        backgroundColor: "rgba(0, 51, 108, 0.14)",
      },
    },
  },
};

export const SELECT_MENU_PROPS = {
  PaperProps: {
    elevation: 0,
    sx: {
      mt: 1,
      borderRadius: "16px",
      border: `1px solid ${BRAND_BORDER}`,
      boxShadow: BRAND_SHADOW,
      overflow: "hidden",
      backgroundImage: "none",
      py: 0.75,
      "& .MuiMenuItem-root": {
        mx: 0.75,
        my: 0.25,
        minHeight: 40,
        borderRadius: "10px",
        color: BRAND_BLUE_DARK,
        fontSize: "0.94rem",
        transition: "background-color 140ms ease, color 140ms ease",
      },
      "& .MuiMenuItem-root.Mui-selected": {
        backgroundColor: "rgba(0, 51, 108, 0.1)",
        color: BRAND_BLUE,
        fontWeight: 700,
      },
      "& .MuiMenuItem-root.Mui-selected:hover": {
        backgroundColor: "rgba(0, 51, 108, 0.14)",
      },
      "& .MuiMenuItem-root:hover": {
        backgroundColor: "rgba(0, 51, 108, 0.06)",
      },
    },
  },
};
